import { b as __assign } from '../../../tslib.es6-14c74580.js';
import React__default, { useRef, useMemo, useCallback, useEffect } from 'react';
import '../../../shared/contexts/TranslationContext.js';
import '../../../shared/contexts/StoreContext.js';
import '../../../shared/core/enums/GameSpecificTypes.js';
import '../../../shared/core/enums/MaxPayoutDataTypes.js';
import '../../../shared/core/enums/Chat.js';
import '../../../shared/core/enums/GameModes.js';
import { IconTypes } from '../../../shared/core/enums/IconTypes.js';
import '../../../shared/core/enums/BetStatus.js';
import '../../../shared/core/enums/PopupTypes.js';
import '../../../shared/core/enums/ApiVersion.js';
import '../../../shared/core/enums/RoundStatus.js';
import '../../../shared/core/enums/FreeBetsStatus.js';
import '../../../shared/core/enums/SocketEvents.js';
import { TranslationKeys } from '../../../shared/core/enums/TranslationKeys.js';
import '../../../shared/core/enums/TimeoutMaxValue.js';
import '../../../shared/core/enums/ApiServiceTypes.js';
import '../../../shared/core/enums/EnvironmentTypes.js';
import '../../../shared/core/enums/DefaultQueryValues.js';
import '../../../shared/core/enums/FreeBetWinningType.js';
import '../../../shared/core/enums/DefaultQueryParams.js';
import '../../../shared/core/enums/BetHistoryFilterTypes.js';
import '../../../shared/core/enums/GameThemeTypes.js';
import '../../../shared/core/enums/RequestStatus.js';
import '../../../shared/core/enums/FetchDefaultPaths.js';
import '../../../shared/core/enums/ResponseCodes.js';
import '../../../loadingStore-a389b52a.js';
import '../../../shared/core/store/chatStore.js';
import '../../../shared/core/store/wageringStore.js';
import '../../../shared/core/store/roundInfoStore.js';
import '../../../shared/core/store/userCountStore.js';
import '../../../shared/core/store/gameResultStore.js';
import '../../../shared/core/store/resultHashStore.js';
import '../../../shared/core/store/userWinBetsStore.js';
import '../../../shared/core/store/notificationStore.js';
import '../../../shared/core/store/selectedResultInfoStore.js';
import '../../../shared/core/services/liveConnection/types.js';
import 'axios';
import '../../../shared/core/services/sound/types.js';
import '../../../shared/core/services/sound/SoundService.js';
import '../../../shared/core/services/sound/defaultSounds.js';
import '../../../shared/core/services/api/types.js';
import '../../../shared/core/services/ApiServices.js';
import '../../../momentFormat-14fce7b4.js';
import '../../../shared/core/polyfill.js';
import 'react-router-dom';
import '../../../shared/core/enums/additionalInputValueChangingButtons.js';
import '../../../shared/providers/storeProvider.js';
import '../../../shared/containers/underMaintenanceContainer/index.js';
import '../../../shared/containers/platformMessagesWrapper/index.js';
import '../../../index-0e073a68.js';
import '../../../shared/containers/gameDrawingWrapper/index.js';
import '../../../shared/components/user-block/user-block-free-bet/index.js';
import '../../../shared/components/game-type-loading/index.js';
import 'mobx';
import '@microsoft/signalr';
import '../../../shared/core/classes/httpResponse/index.js';
import '../../../shared/core/helpers/environmentBuilder.js';
import '../../../shared/core/enums/BogLineGameConfig.js';
import '../../../shared/core/helpers/parseQuery.js';
import '../../../shared/core/services/api/BaseApiService.js';
import '../../../shared/core/enums/StatisticsSortingTypes.js';
import '../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../table-line/t_types/enums/PopupTypes.js';
import '../../../shared/core/helpers/formatDate.js';
import '../../../shared/core/helpers/updateHalfBets.js';
import '../../../shared/core/enums/bogGameNames.js';
import 'howler';
import '../../../_commonjsHelpers-1a7a244d.js';
import 'mobx-react-lite';
import '../../../index-f9fe84d4.js';
import '../../../shared/core/helpers/getAmountWithCurrency.js';
import '../../../shared/core/enums/Currencies.js';
import '../../../shared/hooks/useTranslation.js';
import '../../../shared/core/helpers/setTranslationValues.js';
import '../../../table-line/table-components/lobby/web/lobbyRoomWinner/index.js';
import '../../../shared/core/helpers/maskName.js';
import '../../../shared/core/helpers/exchangeAmountByRate.js';
import '../../../shared/core/helpers/getDataHelper.js';
import '../../../shared/core/helpers/rtlCheckerAndSetter.js';
import '../../../shared/hooks/useAssetsLoadedState.js';
import '../../../table-line/table-components/lobby/web/slider/index.js';
import '../../../shared/core/helpers/convertAmount.js';
import '../../../shared/components/free-bets/free-bet-info/index.js';
import '../../../shared/components/free-bets/free-bets-list/index.js';
import '../../../shared/hooks/useClickOutside.js';
import '../../../table-line/table-components/header/web/logoImg/index.js';
import '../../../table-line/table-components/notification/notification-type-component/index.js';
import '../../../table-line/table-components/notification/notification-wr/index.js';
import '../../../shared/containers/fullScreenWrapper/index.js';
import '../../../shared/hooks/useFullScreen.js';
import '../../../shared/core/helpers/isMobile.js';
import '../snowFlakes/index.js';
import '../../../table-line/table-components/footer/web/footerUserInfoColumn/index.js';
import '../../../table-line/table-components/loading/index.js';
import '../../../table-line/table-components/lobbyLoadingInfoWr/index.js';
import '../../../table-line/table-components/setting/settingRowColumn/index.js';
import '../../../table-line/table-components/accordion/accordionItem.js';
import '../../../table-line/table-components/accordion/context.js';
import '../../../shared/hooks/useUserInfoStore.js';
import '../../../shared/core/helpers/cleanGameTypeIdFromQuery.js';
import '../../../shared/hooks/useLobbyStore.js';
import '../../../table-line/table-components/lobby/web/settingsButton/index.js';
import '../../../table-line/table-components/header/web/headerWr/index.js';
import '../../../table-line/table-components/header/web/headerColumn/index.js';
import '../../../table-line/table-components/header/web/fairnessButton/index.js';
import '../../../table-line/t_types/enums/GameControllerTypes.js';
import '../../../table-line/table-components/gameController/gameControllersWr/index.js';
import '../../../table-line/table-components/gameController/gameControllersHead/index.js';
import '../../../table-line/table-components/gameController/gameControllersContent/index.js';
import '../../../shared/core/enums/gameControllerTypes.js';
import '../../../table-line/table-components/gameController/gameControllersFooter/index.js';
import '../../../shared/hooks/useRoundInfoStore.js';
import '../../../shared/hooks/useUserCountStore.js';
import '../../../shared/hooks/useApplicationStore.js';
import '../../../table-line/table-components/grids/mobile/structureBottom/index.js';
import '../../../table-line/table-components/footer/mobile/footer-wr/index.js';
import '../../../table-line/table-components/footer/mobile/footer-column/index.js';
import '../../../table-line/table-components/footer/mobile/userBalanceAndTotalBet/index.js';
import '../../../table-line/table-components/footer/web/footerInfoSpan/index.js';
import '../../../table-line/table-components/footer/web/footerInfo/index.js';
import '../../../shared/core/helpers/getLocaleTime.js';
import '../../../table-line/table-components/footer/web/footerColumn/index.js';
import '../../../table-line/table-components/footer/web/footerUserInfo/index.js';
import '../../../table-line/table-components/footer/web/footerContainer/index.js';
import '../../../table-line/table-components/footer/web/userBalanceAndTotalBetAmount/index.js';
import '../../../table-line/table-components/footer/web/playForRealButtonHolder/index.js';
import '../../../shared/core/helpers/isIOS.js';
import '../../../table-line/table-components/setting/settingWr/index.js';
import '../../../table-line/table-components/setting/settingRow/index.js';
import '../../../usePopupStore-2ecf4851.js';
import '../../../table-line/table-components/grids/mobile/structureTop/index.js';
import '../../../table-line/table-components/header/mobile/gameId/index.js';
import '../../../table-line/table-components/header/mobile/headerWr/index.js';
import '../../../table-line/table-components/header/mobile/headerLogo/index.js';
import '../../../table-line/table-components/header/mobile/headerColumn/index.js';
import '../../../table-line/table-components/header/mobile/fairnessButton/index.js';
import '../../../table-line/table-components/header/mobile/playForRealButtonHolder/index.js';
import '../../../shared/core/helpers/abbreviateNumber.js';
import '../../../table-line/table-components/header/mobile/minMaxBet/index.js';
import '../../../table-line/table-components/notification/connectionPopUp/index.js';
import '../../../shared/hooks/useSelectedResultInfoStore.js';
import '../../../shared/core/helpers/copyToClipboard.js';
import '../../../shared/hooks/useInfiniteScroll.js';
import '../../../table-line/table-components/accordion/accordion.js';
import '../../../shared/core/helpers/translateMonth.js';
import '../grids/common/pop-up-wr-component/index.js';
import '../list/list-item-with-image/index.js';
import '../list/list/index.js';
import '../list/list-header/index.js';
import '../list/list-item-header/index.js';
import '../list/list-body/index.js';
import '../loading/component/index.js';
import '../loading/logo/index.js';
import '../loading/progress/index.js';
import '../loading/provider/index.js';
import '../loading/loader-content/index.js';
import 'react-dom';
import '../popups/aboutHash.js';
import '../../../shared/hooks/useOpenBetHistory.js';
import '../grids/common/column-body-inner/index.js';
import '../grids/common/column-body-inner-bottom-wr/index.js';
import '../grids/common/column-body-inner-top-wr/index.js';
import '../tabs/tabs/index.js';
import '../tabs/tab-item/index.js';
import '../grids/common/column-header-block/index.js';
import '../grids/common/column-header/index.js';
import '../grids/common/column-header-block-inner/index.js';
import '../icon-block/index.js';
import '../chat/chatActions/index.js';
import '../../../shared/containers/horizontalScrollWrapper/index.js';
import '../chat/chatLoader/index.js';
import '../dots-loader/index.js';
import '../list/list-header-filter/index.js';
import '../list/list-item-header-filter/index.js';
import '../grids/web/game/column/index.js';
import '../grids/web/game/column-inner/index.js';
import '../grids/web/game/column-middle-wr/index.js';
import '../grids/web/game/column-header-wr/index.js';
import '../user-block/user-info/index.js';
import '../user-block/user-content/index.js';
import '../play-for-real-button/index.js';
import '../../../shared/hooks/useOutsideClick.js';
import '../grids/web/game/column-body/index.js';
import '../../../shared/core/helpers/checkScrollToBottom.js';
import '../../../shared/core/enums/GameSceneCodes.js';
import '../navigation/nav-item/index.js';
import '../navigation/nav-row/index.js';
import '../grids/mobile/game/main-cont/index.js';
import '../grids/mobile/game/column/index.js';
import '../notifications/connection-pop-up/index.js';
import '../../../shared/core/helpers/generateUId.js';
import '../../../shared/core/enums/BogLineGameConfigs.js';
import '../../../shared/core/helpers/gameDrawingSupportersFunctions.js';

var defaultNumPadDigitsArray = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0'];
var NumPad = function (_a) {
    var t = _a.t, isOpen = _a.isOpen, limits = _a.limits, onSubmit = _a.onSubmit, amountValue = _a.amountValue, setAmountValue = _a.setAmountValue, _b = _a.precision, precision = _b === void 0 ? 2 : _b, _c = _a.inputMaxLength, inputMaxLength = _c === void 0 ? 9 : _c, _d = _a.numPadDigitsArray, numPadDigitsArray = _d === void 0 ? defaultNumPadDigitsArray : _d;
    var ref = useRef();
    var numPadLimits = useMemo(function () { return (__assign(__assign({}, limits), { step: limits.step || limits.minBet })); }, [limits]);
    var onChange = useCallback(function (event) {
        var value = event.target.value;
        if (/^([0]{1}|([1-9]{1}\d*))(?:\.\d{0,2})?$/.test(value)) {
            return setAmountValue(value);
        }
        if (value === '') {
            return setAmountValue(value);
        }
    }, [setAmountValue]);
    var handleClick = useCallback(function (e) {
        // @ts-ignore
        if (!(ref.current && ref.current.contains(e.target))) {
            onSubmit(null);
        }
    }, [onSubmit]);
    useEffect(function () {
        if (isOpen) {
            document.addEventListener('click', handleClick);
            document.addEventListener('touchstart', handleClick);
            return function () {
                document.removeEventListener('click', handleClick);
                document.removeEventListener('touchstart', handleClick);
            };
        }
    }, [handleClick, isOpen]);
    var handleAddOrMinusBetAmount = function (action) {
        if (action === void 0) { action = undefined; }
        var changedBetAmount;
        if (action === '-') {
            changedBetAmount = +amountValue - numPadLimits.step;
            changedBetAmount = changedBetAmount > numPadLimits.minBet ? changedBetAmount : numPadLimits.minBet;
        }
        else {
            changedBetAmount = +amountValue + numPadLimits.step;
            if (numPadLimits.maxBet) {
                changedBetAmount = changedBetAmount < numPadLimits.maxBet ? changedBetAmount : numPadLimits.maxBet;
            }
        }
        setAmountValue(parseNumberByPrecision(1, changedBetAmount));
    };
    var parseNumberByPrecision = useCallback(function (odd, betAmount) {
        var oddArr = odd.toString().split('.')[1];
        var digitsAfterDotAtOdd = (oddArr && oddArr.length) || 0;
        var digitsAfterDotAtBetAmount = betAmount.toString().split('.').length || 0;
        var digitsCountAfterDot = digitsAfterDotAtBetAmount + digitsAfterDotAtOdd;
        var result;
        var re = new RegExp("^-?\\d+(?:.\\d{0,".concat(precision || 2, "})?"));
        var numMulty = (Math.round(odd * Math.pow(10, digitsCountAfterDot)) * Math.round(betAmount * Math.pow(10, digitsCountAfterDot))) /
            Math.pow(10, (digitsCountAfterDot + digitsCountAfterDot));
        // eslint-disable-next-line prefer-const
        result = +numMulty.toString().match(re) && +numMulty.toString().match(re)[0];
        return result;
    }, []);
    var addDigit = function (digit) {
        if ("".concat(amountValue).concat(digit).length <= inputMaxLength) {
            onChange({ target: { value: "".concat(amountValue).concat(digit) } });
        }
    };
    var deleteDigit = function () {
        onChange({ target: { value: "".concat(amountValue).slice(0, -1) } });
    };
    return (React__default.createElement("div", { className: "numpad-wrapper ".concat(isOpen ? 'active' : ''), ref: ref },
        React__default.createElement("div", { className: 'numpad-holder' },
            React__default.createElement("div", { className: 'num-head-row-holder' },
                React__default.createElement("div", { className: 'numb-calculate-container' },
                    React__default.createElement("div", { className: 'calc-result-numb-row' },
                        React__default.createElement("div", { className: 'calc-result-numb-row-bg' },
                            React__default.createElement("div", { className: "num-head-button-top ".concat(amountValue <= numPadLimits.minBet ? 'disabled' : ''), onClick: function () { return handleAddOrMinusBetAmount('-'); } },
                                React__default.createElement("div", { className: 'num-head-button-inner' },
                                    React__default.createElement("span", { className: 'left-button-item' }, "-"))),
                            React__default.createElement("div", { className: 'middle-container-numb' },
                                React__default.createElement("span", { className: 'money-text' }, amountValue)),
                            React__default.createElement("div", { className: "num-head-button-top ".concat(amountValue >= numPadLimits.maxBet ? 'disabled' : ''), onClick: function () { return handleAddOrMinusBetAmount(); } },
                                React__default.createElement("div", { className: 'num-head-button-inner' },
                                    React__default.createElement("span", { className: 'left-button-item' }, "+")))))),
                React__default.createElement("div", { className: 'num-head-button', onClick: onSubmit },
                    React__default.createElement("button", { className: 'button' },
                        " ",
                        t(TranslationKeys.Ok)))),
            React__default.createElement("div", { className: 'num-button-wrapper' },
                React__default.createElement("div", { className: 'num-button-holder' },
                    numPadDigitsArray.map(function (digit) { return (React__default.createElement("div", { className: 'nub-buttons', key: digit, onClick: function () { return addDigit(digit); } },
                        React__default.createElement("div", { className: 'nub-buttons-inner' },
                            React__default.createElement("span", { className: 'boxes-text' }, digit)))); }),
                    React__default.createElement("div", { className: 'nub-buttons', onClick: function () { return deleteDigit(); } },
                        React__default.createElement("div", { className: 'nub-buttons-inner' },
                            React__default.createElement("i", { className: "ui-lib-".concat(IconTypes.Backspace, " boxes-icon") }))))))));
};

export { NumPad };
